import { Navigate, useLocation } from 'react-router-dom';
import { ONECLICK_OCR_PATH, ONECLICK_RESULTS_PATH } from '@/utils/oneclickJob';

/**
 * Legacy /one-click-mocktest -> the per-step URLs. Saved or running generation
 * results (`?draft=<id>`, `?job=<id>`) open the results step; anything else,
 * including `?ocrDraft=<id>`, opens step 1.
 */
export function OneClickMocktestRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const target = params.has('draft') || params.has('job') ? ONECLICK_RESULTS_PATH : ONECLICK_OCR_PATH;
  return <Navigate to={`${target}${search}`} replace />;
}
